export const READ_SETTINGS = 'AUTH/LOCAL_SETTINGS/READ_SETTINGS'
export const WRITE_SETTINGS = 'AUTH/LOCAL_SETTINGS/WRITE_SETTINGS'
export const SET_SETTINGS = 'AUTH/LOCAL_SETTINGS/SET_SETTINGS'
